// extracted by mini-css-extract-plugin
export default {"detail":"style_detail__tm37A","card":"style_card__0F5D8","content":"style_content__yrEIx","detailActions":"style_detailActions__hBvFQ"};